export default __webpack_public_path__ + "static/media/Exclusivo.80cc327d.jpg";